import { Component } from '@angular/core';

import { ItemTypeEnum } from '@camelot/services';
import { TranslatePipe } from '@camelot/translation';

import { CamTranslationCore } from '../../../../../translation.service';
import { AbstractCellComponent } from '../../abstract';

export const itemTypeEnumLabel = (itemType: number) =>
  `core.item-type.${ItemTypeEnum[itemType]?.toLowerCase() ?? 'unknown'}`;

@Component({
  host: { 'data-cid': 'grid-item-type-enum-cell' },
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: '',
  imports: [TranslatePipe],
  template: `
    @if (this.value !== null) {
      {{ this.itemTypeEnumLabel(this.value) | translate }}
    }
  `,
})
export class GridItemTypeEnumCellComponent extends AbstractCellComponent<any, number> {
  public itemTypeEnumLabel = itemTypeEnumLabel;

  constructor() {
    super();
    CamTranslationCore.getInstance();
  }
}
